/**
 * Pre-authored broadcast email templates the admin can one-click load.
 * Each template returns { subject, body_html, audience, hint }.
 * Audience hint is suggested but admin can override.
 */

export const FOUNDING_OFFER_TEMPLATE = {
  key: "founding-offer",
  label: "Founding Member offer",
  description: "Announce the first-100 founder offer to your free users",
  audience: "free",
  subject: "A note from Michael — and a small gift for the first 100",
  body_html: `<p style="font-size:16px;line-height:1.6;color:#3D3935;">Hi there,</p>

<p style="font-size:16px;line-height:1.6;color:#3D3935;">
  I built Hope Chest because I watched my own family lose track of doctors, medications, and the small daily details
  of caring for someone we loved. There has to be a better way than shoeboxes and group texts.
</p>

<p style="font-size:16px;line-height:1.6;color:#3D3935;">
  We're still in the very first chapter of building this — and I want you in it.
</p>

<div style="background:linear-gradient(135deg,#3A5A4A,#2C4538);color:#FFFFFF;padding:28px;border-radius:16px;margin:24px 0;">
  <p style="font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:#E8DCC8;margin:0 0 8px;">Limited — only 100 spots</p>
  <h2 style="font-family:Georgia,serif;font-size:26px;margin:0 0 12px;color:#FFFFFF;">Become a Founding Member</h2>
  <p style="font-size:15px;line-height:1.6;margin:0 0 16px;color:rgba(255,255,255,0.92);">
    Join Hope Chest Premium today for <strong>$14.99/month</strong> (or $99/year) and lock that rate in for life. As we grow,
    every new feature lands in your chest at no extra cost. Ever.
  </p>
  <ul style="font-size:14px;line-height:1.7;margin:0 0 18px;padding-left:18px;color:rgba(255,255,255,0.92);">
    <li>🔒 Price locked for life — even when we raise prices for everyone else</li>
    <li>🎁 All future Premium features free — no upsells, no add-ons</li>
    <li>⭐ Founding Member badge on your profile</li>
    <li>💬 A direct line to me — reply to any of my emails any time</li>
    <li>🙏 The knowledge that you helped build this for a family who needed it</li>
  </ul>
  <a href="{{app_origin}}/pricing#founding" style="display:inline-block;background:#E8DCC8;color:#2C4538;padding:14px 32px;border-radius:999px;text-decoration:none;font-weight:600;">Become a Founding Member →</a>
</div>

<p style="font-size:16px;line-height:1.6;color:#3D3935;">
  Only 100 spots. After that, the door closes and standard pricing applies. You'll always be able to use
  Hope Chest for free with one loved one — this offer is for the few who want to come along for the ride.
</p>

<p style="font-size:16px;line-height:1.6;color:#3D3935;">
  Thank you for being here in these earliest days. Reply to this email any time — I read every single one.
</p>

<p style="font-size:16px;line-height:1.6;color:#3D3935;margin-top:24px;">
  Warmly,<br />
  <strong>Michael</strong><br />
  <span style="color:#7A736E;font-size:14px;">Organized Hope · Huntsville, AL</span>
</p>`,
};

export const BROADCAST_TEMPLATES = [FOUNDING_OFFER_TEMPLATE];
